import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=77195bf2&scoped=true&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"
import style0 from "./pricelist.vue?vue&type=style&index=0&id=77195bf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77195bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77195bf2')) {
      api.createRecord('77195bf2', component.options)
    } else {
      api.reload('77195bf2', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=77195bf2&scoped=true&", function () {
      api.rerender('77195bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pricelist.vue"
export default component.exports